<template>
  <div class="element-item">
    <div class="element-group flex justify-between items-center mb-4">
      <div class="text-xl">{{$t('main.barrier')}}</div>
      <div
        v-if="barrier.total && settings.with_calc_price == 1 && !isComplectation"
        class="font-bold text-xl mt-2 text-right"
      >
        {{ $toCurrency(barrier.total) }}
      </div>
      <button
        v-if="isComplectation"
        class="font-light"
        @click="$store.dispatch('clientOrder/removeBarrier')"
      >
        <i class="fas fa-times"></i>
      </button>
    </div>
    <div class="element-detail flex justify-between">
      <div class="image">
        <div class="image-wrapper">
          <div
            class="image-src"
            :style="{ backgroundImage: `url(${barrier.image})` }"
          ></div>
        </div>
      </div>
      <div class="detail w-full text-sm">
        <div class="flex justify-between">
          <div>
            <span class="font-bold">{{$t('main.name')}}: </span>
            <span>{{ barrier.name }}</span>
          </div>

          <span
            class="whitespace-nowrap"
            v-if="settings.with_calc_price == 1"
          >{{ $toCurrency(barrier.price_pog_metr) }}/{{$t('main.m_p')}}</span>
        </div>
        <div>
          <span class="font-bold">{{$t('main.article')}}: </span>
          <span>{{ barrier.article }}</span>
        </div>
        <div>
          <span class="font-bold">{{$t('main.door')}}: </span>
          <span>
            {{ barrier.kalitka ? barrier.kalitka : "" }}
          </span>
        </div>
        <div>
          <span class="font-bold">{{$t('main.sizes')}}: </span>
          <span>{{ barrier.sizes }}</span>
        </div>
        <div>
          <span class="font-bold">{{$t('main.metraz')}}: </span>
          <span>{{ barrier.perimetr }} {{$t('main.m_p')}}</span>
        </div>
        <div>
          <span class="font-bold">{{$t('main.type')}}: </span>
          <span>{{ barrier.type_name }}</span>
        </div>

        <div v-if="settings.with_calc_price == 1">
          <span class="font-light text-gray-600 italic text-xs">{{$t('client.complectation.cost_install_barrier')}}:
          </span>
          <span class="text-gray-600 italic">{{ $toCurrency(barrier.final_price_installation) }}
          </span>
        </div>
        <div v-if="barrier.doorPosition&&barrier.doorPosition.wherePlace =='placeCenter'&&barrier.price_add_stolbik&&settings.with_calc_price == 1">
          <span class="font-light text-gray-600 italic text-xs">{{$t('main.barrier_price_add_stolbik')}}:
          </span>
          <span class="text-gray-600 italic">{{ $toCurrency(barrier.price_add_stolbik) }}
          </span>
        </div>

        <div
          v-if="barrier.total && settings.with_calc_price == 1 && isComplectation"
          class="font-bold text-xl mt-2 text-right"
        >
          {{ $toCurrency(barrier.total) }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    barrier: {
      type: Object,
      required: true,
    },
    settings: {
      type: Object,
      required: true,
    },
    isComplectation: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
